module.exports = __webpack_public_path__ + "img/1530845256.7d227a21.jpg";